// extracted by mini-css-extract-plugin
export default {"container":"searchClient_container__vP0Em","input":"searchClient_input__IZSIn"};